import { Interval } from '@shared/utils/History/Interval';
import { Periods } from '@shared/utils/History/TFInfo';
import { TimeSpanPeriods } from '@shared/utils/Time/TimeSpan';
import { HistoryMerger } from './HistoryMerger';
import { Decimal } from 'decimal.js';
export class HistoryMergerBySeconds extends HistoryMerger {
    constructor(inputParams) {
        super(inputParams);
    }
    /** old algorithm (from Jan 1 1970 ) */
    FindIntervalBorders(date) {
        const data = date.getTime();
        const period = this.newPeriod / Periods.SECOND;
        const barLength = period * TimeSpanPeriods.TicksPerSecond;
        const periodsCountFractional = new Decimal(data).div(barLength);
        const periodsCount = periodsCountFractional.trunc().toNumber();
        const barStartInTicks = periodsCount * barLength;
        const barEndInTicks = barStartInTicks + barLength;
        const interval = new Interval();
        interval.From = new Date(barStartInTicks);
        interval.To = new Date(barEndInTicks);
        return interval;
    }
}
